import { ApiResponse, Service } from '@roc/feature-app-core';

const url = {
  ALL_INSPECTIONS: '/api/v1/inspection/inspections',
  GET_INSPECTION_DETAILS: '/api/v1/inspection/getInspectionDetails',
  GET_INSPECTION_DETAILS_BY_EXTERNAL_IDS: '/api/v1/inspection/getInspectionDetailsByExternalIds'
};

export class InspectionService extends Service {
  public getAllInspections(
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    filters: string,
    dropdownFilters: string
  ): Promise<ApiResponse> {
    const params = {
      page,
      pageSize,
      sortBy,
      sortDir,
      filters,
      dropdownFilters,
    };

    return this.get(url.ALL_INSPECTIONS, params, {
      disableGlobalLoading: true,
    });
  }

  getInspectionDetails(inspectionId: number) {
    return this.get(url.GET_INSPECTION_DETAILS, { inspectionId });
  }

  getInspectionDetailsByExternalIds(externalId1: number, externalId2: number) {
    return this.get(url.GET_INSPECTION_DETAILS_BY_EXTERNAL_IDS, { externalId1, externalId2 });
  }
}
